// Platform Configurations - Data Pulling for AI Assistant
import { Platform, PlatformCategory } from '../types';

export const PLATFORM_CATEGORIES: Record<PlatformCategory, { label: string; labelEn: string; icon: string; color: string }> = {
  marketplace: {
    label: 'Pazaryerleri',
    labelEn: 'Marketplaces',
    icon: 'Store',
    color: '#F59E0B',
  },
  ecommerce: {
    label: 'E-Ticaret Siteleri',
    labelEn: 'E-Commerce Platforms',
    icon: 'ShoppingCart',
    color: '#10B981',
  },
  advertising: {
    label: 'Reklam Platformları',
    labelEn: 'Advertising',
    icon: 'Megaphone',
    color: '#EF4444',
  },
  analytics: {
    label: 'Raporlama & Analitik',
    labelEn: 'Analytics & Reporting',
    icon: 'BarChart3',
    color: '#3B82F6',
  },
  accounting: {
    label: 'Muhasebe & Finans',
    labelEn: 'Accounting & Finance',
    icon: 'Calculator',
    color: '#8B5CF6',
  },
};

export const PLATFORMS: Platform[] = [
  // Marketplaces - Veri Çekme
  {
    id: 'trendyol',
    name: 'Trendyol',
    category: 'marketplace',
    icon: '/platforms/trendyol.svg',
    color: '#F27A1A',
    description: 'Türkiye\'nin en büyük e-ticaret pazaryeri',
    features: ['Satış verileri', 'Ürün performansı', 'Sipariş analitiği', 'Rakip fiyatları'],
    connectionBenefit: 'Trendyol mağazanızı bağladığınızda günlük satış rakamları, sipariş detayları ve ürün bazlı performans verileri otomatik olarak çekilir. Yapay zeka bu verileri analiz ederek hangi ürünlerinizin trend olduğunu, hangi saatlerde daha çok satış yaptığınızı ve rakiplerinize göre fiyat konumunuzu gösterir. Böylece stok planlamanızı optimize edebilir, kampanya zamanlamanızı iyileştirebilir ve kârlılığınızı artırabilirsiniz.',
    authType: 'api_key',
    docsUrl: 'https://developers.trendyol.com',
  },
  {
    id: 'hepsiburada',
    name: 'Hepsiburada',
    category: 'marketplace',
    icon: '/platforms/hepsiburada.svg',
    color: '#FF6000',
    description: 'Türkiye\'nin lider e-ticaret platformu',
    features: [
      'Satış verileri',
      'Ürün yönetimi',
      'Sipariş analitiği',
      'Stok & Fiyat güncelleme',
      'İade/Talep takibi',
      'Satıcı Soru-Cevap',
      'Muhasebe raporları',
      'Komisyon oranları',
      'Hepsilojistik entegrasyonu'
    ],
    connectionBenefit: 'Hepsiburada entegrasyonu ile mağazanızdaki tüm sipariş geçmişi, ürün yönetimi, stok ve fiyat güncellemeleri tek panelden kontrol edilir. İade ve talep süreçleri, müşteri sorularına yanıtlar, muhasebe dönemleri ve komisyon oranları otomatik çekilir. Kategori bazlı performans analizi, Buybox durumu ve Hepsilojistik verileri sayesinde satış stratejinizi optimize edersiniz. Yapay zeka tüm bu verileri analiz ederek fiyat optimizasyonu, stok planlaması ve ürün açıklaması iyileştirme önerileri sunar.',
    authType: 'api_key',
    docsUrl: 'https://developers.hepsiburada.com',
  },
  {
    id: 'amazon-tr',
    name: 'Amazon Türkiye',
    category: 'marketplace',
    icon: '/platforms/amazon.svg',
    color: '#FF9900',
    description: 'Global e-ticaret devi',
    features: ['Satış verileri', 'FBA raporları', 'Ürün sıralamaları'],
    connectionBenefit: 'Amazon hesabınızı bağladığınızda FBA (Fulfillment by Amazon) envanter durumu, satış sıralamaları ve Buy Box kazanma oranlarınız anlık takip edilir. Uluslararası satış yapıyorsanız ülke bazlı performans karşılaştırması yapabilirsiniz. Yapay zeka, Amazon\'un algoritmasına uygun ürün başlığı ve anahtar kelime önerileri sunarak organik görünürlüğünüzü artırmanıza yardımcı olur.',
    authType: 'oauth2',
    docsUrl: 'https://developer.amazonservices.com',
  },
  {
    id: 'n11',
    name: 'n11',
    category: 'marketplace',
    icon: '/platforms/n11.svg',
    color: '#00B14F',
    description: 'Türkiye\'nin önde gelen pazaryeri',
    features: ['Satış verileri', 'Ürün performansı', 'Sipariş analitiği', 'Kategori yönetimi'],
    connectionBenefit: 'n11 mağazanızın satış verileri ve müşteri yorumları otomatik olarak çekilecek. Kategori bazlı pazar payınızı görebilir, rakip ürünlerle fiyat karşılaştırması yapabilirsiniz. Entegrasyon aktif olduğunda sezonluk satış trendlerinizi analiz edip gelecek dönem için stok ve bütçe planlaması yapmanıza yardımcı oluruz.',
    authType: 'api_key',
    docsUrl: 'https://magazadestek.n11.com',
  },
  {
    id: 'ciceksepeti',
    name: 'Çiçeksepeti',
    category: 'marketplace',
    icon: '/platforms/ciceksepeti.svg',
    color: '#7B2D8E',
    description: 'Hediye ve çiçek pazaryeri',
    features: [
      'Ürün listeleme',
      'Sipariş yönetimi',
      'Kategori bilgileri',
      'İade/İptal takibi',
      'Müşteri soruları',
      'Stok & Fiyat güncelleme',
    ],
    connectionBenefit: 'Çiçeksepeti\'nin özel günlere dayalı satış yapısı nedeniyle tarih bazlı analiz çok önemlidir. Bağlantı kurulduğunda Sevgililer Günü, Anneler Günü gibi özel günlerdeki performansınız detaylı analiz edilir. Ürünlerinizi, siparişlerinizi, iade süreçlerinizi ve müşteri sorularını tek panelden yönetirsiniz. Hangi ürün kombinasyonlarının daha çok tercih edildiğini, teslimat bölgelerine göre satış dağılımınızı görebilir ve gelecek özel günlere önceden hazırlanabilirsiniz.',
    authType: 'api_key',
    docsUrl: 'https://ciceksepeti.dev',
  },
  {
    id: 'pttavm',
    name: 'PttAVM',
    category: 'marketplace',
    icon: '/platforms/pttavm.svg',
    color: '#FFD700',
    description: 'PTT e-ticaret platformu',
    features: [
      'Ürün listeleme',
      'Sipariş yönetimi',
      'Kategori bilgileri',
      'Stok takibi',
      'Satış verileri',
    ],
    connectionBenefit: 'PttAVM\'nin yaygın kargo ağı avantajını ne kadar kullandığınızı analiz ederiz. Bağlantı sonrası kargo teslimat süreleri, il bazlı satış dağılımı ve müşteri memnuniyet verileri sisteme aktarılır. Ürün listeleme, stok ve sipariş yönetimi tek panelden yapılır. Özellikle Anadolu\'daki satış potansiyelinizi değerlendirmek ve lojistik maliyetlerinizi optimize etmek için öneriler alırsınız.',
    authType: 'credentials',
    docsUrl: 'https://developers.pttavm.com',
  },
  {
    id: 'boyner',
    name: 'Boyner',
    category: 'marketplace',
    icon: '/platforms/boyner.svg',
    color: '#000000',
    description: 'Premium moda ve yaşam pazaryeri',
    features: ['Satış verileri', 'Ürün performansı', 'Sipariş analitiği'],
    connectionBenefit: 'Boyner\'in premium müşteri kitlesine ulaşırken marka konumlandırmanızı analiz ederiz. Moda trendleri, sezonsal satış kalıpları ve fiyat segmentasyonu verileri çekilir. Üst gelir grubu tüketici davranışları ve marka sadakati analizleri ile premium fiyatlandırma stratejinizi optimize edersiniz.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'beymen',
    name: 'Beymen',
    category: 'marketplace',
    icon: '/platforms/beymen.svg',
    color: '#000000',
    description: 'Lüks moda pazaryeri',
    features: ['Satış verileri', 'Ürün performansı', 'Sipariş analitiği', 'Marka yönetimi'],
    connectionBenefit: 'Beymen\'in lüks segment müşterilerine satış yapıyorsanız, yüksek ticket size analitiği ve VIP müşteri davranışları raporlanır. Tasarımcı marka performansları, koleksiyon bazlı satış trendleri ve sezon sonu indirim optimizasyonu için öneriler sunulur. Lüks tüketici segmentinin beklentilerini karşılamak için içgörüler elde edersiniz.',
    authType: 'api_key',
    docsUrl: 'https://partner-docs.beymen.com',
  },
  {
    id: 'turkcell-pasaj',
    name: 'Turkcell Pasaj',
    category: 'marketplace',
    icon: '/platforms/turkcell-pasaj.svg',
    color: '#FFD100',
    description: 'Turkcell e-ticaret platformu',
    features: ['Satış verileri', 'Sipariş analitiği'],
    connectionBenefit: 'Turkcell\'in geniş müşteri tabanına erişirken GSM abonesi demografisi ve taksitli alışveriş davranışları analiz edilir. Paycell ve Turkcell ödeme yöntemlerinin dönüşüm oranlarını görebilirsiniz. Mobil öncelikli müşteri kitlesinin alışveriş alışkanlıkları ve cihaz bazlı satış performansı raporlanır.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'pazarama',
    name: 'Pazarama',
    category: 'marketplace',
    icon: '/platforms/pazarama.svg',
    color: '#FF6B00',
    description: 'Hızlı büyüyen pazaryeri',
    features: ['Satış verileri', 'Sipariş analitiği'],
    connectionBenefit: 'Pazarama\'nın dinamik büyüme stratejisinde yerinizi alırken erken dönem satıcı avantajlarınızı değerlendiririz. Kategori bazlı rekabet analizi, yeni pazaryeri algoritması optimizasyonu ve müşteri edinme maliyetleri raporlanır. Büyüyen platformdaki organik görünürlük fırsatlarını yakalamak için öneriler sunulur.',
    authType: 'api_key',
    comingSoon: true,
  },

  // E-Commerce Platforms - Veri Çekme
  {
    id: 'woocommerce',
    name: 'WooCommerce',
    category: 'ecommerce',
    icon: '/platforms/woocommerce.svg',
    color: '#96588A',
    description: 'WordPress e-ticaret eklentisi',
    features: ['Satış verileri', 'Müşteri verileri', 'Ürün performansı'],
    connectionBenefit: 'WordPress sitenize kurulu WooCommerce mağazanızın tüm verileri API üzerinden güvenli şekilde çekilir. Müşteri satın alma geçmişi, sepet terk oranları, kupon kullanım istatistikleri ve ürün bazlı kârlılık analizleri yapılır. Tekrar eden müşteri oranınızı, ortalama sepet tutarınızı ve müşteri yaşam boyu değerini (LTV) hesaplayarak pazarlama stratejinizi şekillendirmenize yardımcı oluruz.',
    authType: 'api_key',
  },
  {
    id: 'shopify',
    name: 'Shopify',
    category: 'ecommerce',
    icon: '/platforms/shopify.svg',
    color: '#95BF47',
    description: 'Global e-ticaret platformu',
    features: ['Satış verileri', 'Müşteri verileri', 'Trafik analitiği'],
    connectionBenefit: 'Shopify mağazanızı bağladığınızda satış verileriyle birlikte trafik kaynakları da analiz edilir. Hangi kanaldan gelen ziyaretçilerin daha çok satın aldığını, mobil ve masaüstü dönüşüm oranlarınızı karşılaştırabilirsiniz. Ürün varyantlarının performansı, stok devir hızı ve kargo maliyetlerinin kârlılığa etkisi gibi detaylı raporlar sunulur. E-posta pazarlama ve sosyal medya kampanyalarınızın gerçek ROI\'sini ölçebilirsiniz.',
    authType: 'oauth2',
  },
  {
    id: 'ikas',
    name: 'ikas',
    category: 'ecommerce',
    icon: '/platforms/ikas.svg',
    color: '#4F46E5',
    description: 'Türk e-ticaret altyapısı',
    features: ['Satış verileri', 'Müşteri verileri', 'Sipariş analitiği'],
    connectionBenefit: 'Türkiye\'ye özel geliştirilmiş ikas altyapınızın verilerini çekerek yerel pazara uygun analizler sunarız. Sanal POS komisyon oranları, kargo anlaşmalarınızın maliyet etkinliği ve Türk tüketici davranışlarına göre satış saatleri analiz edilir. Bayram, indirim dönemleri ve maaş günleri gibi Türkiye\'ye özgü alışveriş alışkanlıklarına göre kampanya zamanlaması önerileri alırsınız.',
    authType: 'api_key',
  },
  {
    id: 'ticimax',
    name: 'Ticimax',
    category: 'ecommerce',
    icon: '/platforms/ticimax.svg',
    color: '#00BCD4',
    description: 'Türk e-ticaret altyapısı',
    features: ['Satış verileri', 'Müşteri verileri'],
    connectionBenefit: 'Ticimax altyapılı mağazanızın çok kanallı satış verilerini tek panelde görmenizi sağlarız. Pazaryeri entegrasyonlarınızla birlikte kendi sitenizin performansını karşılaştırabilir, hangi kanalda daha kârlı sattığınızı anlayabilirsiniz. Müşteri segmentasyonu yaparak VIP müşterilerinize özel kampanya stratejileri geliştirmenize yardımcı oluruz.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'ideasoft',
    name: 'IdeaSoft',
    category: 'ecommerce',
    icon: '/platforms/ideasoft.svg',
    color: '#1E88E5',
    description: 'Türk e-ticaret altyapısı',
    features: ['Satış verileri', 'Müşteri verileri'],
    connectionBenefit: 'IdeaSoft\'un güçlü B2B özellikleriyle birlikte toptan ve perakende satış verilerinizi ayrı ayrı analiz ederiz. Bayi performansları, taksitli satış oranları ve kurumsal müşteri davranışları raporlanır. Stok alarm seviyeleri ve tedarik sürelerinizi optimize ederek sermaye verimliliğinizi artırmanıza yardımcı oluruz.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'odoo',
    name: 'Odoo',
    category: 'ecommerce',
    icon: '/platforms/odoo.svg',
    color: '#875A7B',
    description: 'Açık kaynak ERP ve e-ticaret',
    features: ['Satış verileri', 'Müşteri verileri', 'Stok verileri', 'CRM verileri'],
    connectionBenefit: 'Odoo\'nun modüler yapısından gelen verilerle e-ticaret, CRM, stok ve muhasebe verilerinizi bütünleşik analiz ederiz. Satış hunisi performansı, lead dönüşüm oranları ve müşteri yaşam döngüsü takibi yapılır. Üretim modülü kullanıyorsanız BOM (Bill of Materials) ve üretim maliyetleri ile gerçek kârlılık hesaplanır.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'wix',
    name: 'Wix',
    category: 'ecommerce',
    icon: '/platforms/wix.svg',
    color: '#0C6EFC',
    description: 'Web sitesi ve e-ticaret platformu',
    features: ['Satış verileri', 'Müşteri verileri', 'Trafik analitiği'],
    connectionBenefit: 'Wix mağazanızın satış verileri, site trafiği ve form dönüşümleri analiz edilir. Wix Analytics verilerini e-ticaret performansınızla birleştirerek ziyaretçi davranışlarını satış sonuçlarıyla ilişkilendirirsiniz. Blog içeriklerinizin satışlara etkisi, popup ve form performansları raporlanır.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'tsoft',
    name: 'T-Soft',
    category: 'ecommerce',
    icon: '/platforms/tsoft.svg',
    color: '#E31E24',
    description: 'Türk e-ticaret altyapısı',
    features: ['Satış verileri', 'Müşteri verileri', 'Sipariş analitiği'],
    connectionBenefit: 'T-Soft altyapınızın çok kanallı satış verilerini tek noktada toplarız. Pazaryeri entegrasyonlarınız ve kendi sitenizin performansını karşılaştırır, kanal bazlı kârlılık analizi yaparsınız. Kampanya modülü verileri ile hangi indirimlerin en iyi dönüşüm sağladığını görürsünüz.',
    authType: 'api_key',
    comingSoon: true,
  },

  // Google - Unified Platform (All Google Services)
  {
    id: 'google',
    name: 'Google',
    category: 'analytics',
    icon: '/platforms/google.svg',
    color: '#4285F4',
    description: 'Tüm Google servisleri tek bağlantıda',
    features: [
      'Google Analytics 4',
      'Google Search Console',
      'Google Merchant Center',
      'Google Ads',
      'YouTube Analytics',
      'Gmail',
      'Google Calendar'
    ],
    connectionBenefit: 'Google hesabınızı bağladığınızda Analytics, Search Console, Merchant Center, Ads, YouTube Analytics, Gmail ve Calendar verilerinize tek tıkla erişim sağlarsınız. Tüm Google ekosistemindeki verileriniz yapay zeka tarafından analiz edilerek e-ticaret performansınızın bütünsel bir resmini görmenizi sağlar. SEO performansı, reklam harcamaları, site trafiği, ürün listelemesi ve daha fazlası tek panelde birleşir.',
    authType: 'oauth2',
    docsUrl: 'https://developers.google.com',
  },

  // Advertising Platforms - Veri Çekme
  // Note: Google Ads is now part of unified 'google' platform
  {
    id: 'meta-ads',
    name: 'Meta Ads',
    category: 'advertising',
    icon: '/platforms/meta.svg',
    color: '#1877F2',
    description: 'Facebook & Instagram reklamları',
    features: ['Kampanya performansı', 'Harcama verileri', 'Hedef kitle analitiği'],
    connectionBenefit: 'Facebook ve Instagram reklam hesaplarınız bağlandığında hedef kitle demografileri, reklam görseli performansları ve yerleşim bazlı (feed, story, reels) sonuçlar analiz edilir. A/B test sonuçlarınız değerlendirilerek en iyi performans gösteren kreatifler belirlenir. Lookalike audience önerileri ve retargeting stratejileri için veri destekli öneriler alırsınız. iOS güncellemelerinin etkisini ve attribution penceresi değişikliklerini de takip ederiz.',
    authType: 'oauth2',
    docsUrl: 'https://developers.facebook.com/docs/marketing-apis',
  },
  {
    id: 'tiktok-ads',
    name: 'TikTok Ads',
    category: 'advertising',
    icon: '/platforms/tiktok.svg',
    color: '#000000',
    description: 'TikTok reklam platformu',
    features: ['Kampanya performansı', 'Video metrikleri', 'Harcama verileri'],
    connectionBenefit: 'TikTok\'un genç ve dinamik kullanıcı kitlesine ulaşırken hangi içeriklerin viral olduğunu analiz ederiz. Video tamamlanma oranları, ses kullanımı etkileri ve trend hashtag performansları raporlanır. Spark Ads ve In-Feed reklamlarınızın karşılaştırmalı performansını görebilir, influencer iş birliklerinizin gerçek etkisini ölçebilirsiniz. Z kuşağı ve milenyum kuşağı için içerik stratejisi önerileri sunulur.',
    authType: 'oauth2',
    comingSoon: true,
  },
  {
    id: 'criteo',
    name: 'Criteo',
    category: 'advertising',
    icon: '/platforms/criteo.svg',
    color: '#F8A01E',
    description: 'Retargeting reklam platformu',
    features: ['Retargeting performansı', 'Dönüşüm verileri'],
    connectionBenefit: 'Criteo\'nun güçlü retargeting motorundan gelen verilerle sepet terk eden müşterilerin geri kazanım oranını ölçersiniz. Dinamik ürün reklamlarının her bir SKU bazında performansı analiz edilir. Çapraz satış önerilerinin ne kadar etkili olduğunu, müşteri yolculuğundaki temas noktalarını ve attribution modellemesini detaylı görürsünüz. Diğer reklam kanallarıyla birlikte bütünleşik ROAS hesaplaması yapılır.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'amazon-ads',
    name: 'Amazon Ads',
    category: 'advertising',
    icon: '/platforms/amazon-ads.svg',
    color: '#FF9900',
    description: 'Amazon reklam platformu',
    features: ['Sponsored Products', 'Sponsored Brands', 'Kampanya performansı', 'ACoS analizi'],
    connectionBenefit: 'Amazon Ads entegrasyonu ile Sponsored Products, Sponsored Brands ve Sponsored Display kampanyalarınızın performansını tek bir yerden izlersiniz. ACoS (Advertising Cost of Sale), TACoS ve ROAS metriklerinizi detaylı analiz ederek reklam bütçenizi optimize edersiniz. Anahtar kelime bazlı performans, negatif anahtar kelime önerileri ve bid optimizasyonu için yapay zeka destekli öneriler alırsınız. Amazon\'daki organik sıralamanızla reklam performansınızın ilişkisini analiz edebilirsiniz.',
    authType: 'oauth2',
    docsUrl: 'https://advertising.amazon.com/API/docs',
    comingSoon: true,
  },

  // Analytics Platforms - Veri Çekme
  // Note: Google Analytics, Search Console, Merchant Center are now part of unified 'google' platform
  {
    id: 'yandex-metrica',
    name: 'Yandex Metrica',
    category: 'analytics',
    icon: '/platforms/yandex.svg',
    color: '#FF0000',
    description: 'Web sitesi analitik platformu',
    features: ['Trafik verileri', 'Kullanıcı davranışları'],
    connectionBenefit: 'Yandex Metrica\'nın session replay ve ısı haritası özelliklerinden gelen kullanıcı davranış verileri analiz edilir. Rusya ve Türk Cumhuriyetleri\'nden gelen trafiğinizi detaylı değerlendirebilirsiniz. Form analizi ile hangi alanların kullanıcıları zorladığını, sayfa kaydırma derinliğiyle içerik etkileşimini ölçeriz. GA4 ile çapraz doğrulama yaparak veri tutarlılığınızı kontrol edebilirsiniz.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'hotjar',
    name: 'Hotjar',
    category: 'analytics',
    icon: '/platforms/hotjar.svg',
    color: '#FF3C00',
    description: 'Kullanıcı davranış analizi',
    features: ['Heatmap verileri', 'Session kayıtları'],
    connectionBenefit: 'Hotjar\'ın görsel analiz araçlarından gelen verilerle kullanıcıların gerçekte ne yaptığını görürsünüz. Tıklama ısı haritaları hangi CTA\'ların çalıştığını, kaydırma haritaları içeriğin ne kadarının görüldüğünü gösterir. Session kayıtlarından elde edilen frustration signals (öfke tıklamaları, hızlı geri dönüşler) analiz edilerek UX sorunları tespit edilir. Anket ve feedback widget verilerini müşteri memnuniyet skoru (NPS) ile birlikte değerlendirirsiniz.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'clarity',
    name: 'Microsoft Clarity',
    category: 'analytics',
    icon: '/platforms/clarity.svg',
    color: '#0078D4',
    description: 'Ücretsiz kullanıcı davranış analizi',
    features: ['Heatmap verileri', 'Session kayıtları', 'Insights'],
    connectionBenefit: 'Microsoft Clarity\'nin ücretsiz ve sınırsız session kayıt özelliği ile kullanıcı davranışlarını derinlemesine analiz ederiz. Dead clicks, rage clicks ve quick backs gibi frustration metrikleri otomatik tespit edilir. Heatmap verileri ve scroll derinliği analizi ile sayfalarınızın gerçek performansını görürsünüz. Copilot AI destekli insights ile sorunlu alanlar otomatik raporlanır.',
    authType: 'api_key',
    comingSoon: true,
  },

  // Accounting Platforms - Veri Çekme
  {
    id: 'parasut',
    name: 'Paraşüt',
    category: 'accounting',
    icon: '/platforms/parasut.svg',
    color: '#00C853',
    description: 'Online muhasebe ve fatura yönetimi',
    features: ['Gelir/gider verileri', 'Nakit akışı', 'Kârlılık analizi'],
    connectionBenefit: 'Paraşüt\'ten çekilen fatura ve gider verileriyle gerçek kârlılığınızı hesaplarız. Satış verilerinizle muhasebe verilerinizi eşleştirerek ürün bazlı net kâr marjları çıkarılır. Nakit akışı tahminleri yapılarak ödeme vadeleriniz optimize edilir. KDV, stopaj ve diğer vergi yükümlülükleriniz takip edilir. Aylık kapanış raporları ve finansal dashboard\'lar ile işletmenizin mali sağlığını tek bakışta görürsünüz. Tedarikçi ödeme performansınız ve müşteri tahsilat süreleri analiz edilir.',
    authType: 'oauth2',
    docsUrl: 'https://apidocs.parasut.com',
  },
  {
    id: 'logo',
    name: 'Logo',
    category: 'accounting',
    icon: '/platforms/logo.svg',
    color: '#003366',
    description: 'Kurumsal muhasebe yazılımı',
    features: ['Finansal veriler', 'Maliyet verileri'],
    connectionBenefit: 'Logo\'nun kapsamlı ERP verilerini e-ticaret satış verilerinizle birleştirerek kurumsal düzeyde analiz sunarız. Maliyet muhasebesinden gelen verilerle ürün bazlı kârlılık, departman performansı ve bütçe sapma analizleri yapılır. Stok değerleme yöntemlerinizin (FIFO, LIFO, ortalama maliyet) kârlılığa etkisini görebilirsiniz. Konsolidasyon raporları ve şirketler arası mutabakat takibi kurumsal yapılar için sunulur.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'mikro',
    name: 'Mikro',
    category: 'accounting',
    icon: '/platforms/mikro.svg',
    color: '#0066CC',
    description: 'KOBİ muhasebe yazılımı',
    features: ['Finansal veriler', 'Maliyet verileri'],
    connectionBenefit: 'KOBİ\'lere özel Mikro yazılımının pratik raporlama yapısını yapay zeka destekli analizlerle güçlendiriyoruz. Cari hesap bakiyeleri, çek-senet takibi ve banka mutabakatları otomatik çekilir. Alacak yaşlandırma raporları ile tahsilat riski olan müşteriler erkenden tespit edilir. Kâr-zarar tablosu ve bilanço verileri trend analizine tabi tutularak finansal sağlık skoru oluşturulur. E-ticaret cirolarınızla muhasebe kayıtları arasındaki uyumsuzluklar otomatik tespit edilir.',
    authType: 'api_key',
    comingSoon: true,
  },
  {
    id: 'luca',
    name: 'Luca',
    category: 'accounting',
    icon: '/platforms/luca.svg',
    color: '#6366F1',
    description: 'Online muhasebe platformu',
    features: ['Gelir/gider verileri', 'Raporlama'],
    connectionBenefit: 'Luca\'nın bulut tabanlı yapısı sayesinde gerçek zamanlı finansal verilerinize erişiriz. E-fatura ve e-arşiv fatura verileri otomatik kategorizasyona tabi tutulur. Gider kalemlerinizin satışlara oranı, sabit ve değişken maliyet analizi yapılır. Aylık gider trendleriniz izlenerek anormal harcamalar tespit edilir. Vergi takvimi entegrasyonu ile beyanname dönemlerinde hazırlıklı olmanız sağlanır. Muhasebeci ile paylaşılabilir raporlar otomatik oluşturulur.',
    authType: 'api_key',
    comingSoon: true,
  },
];

export const getPlatformById = (id: string): Platform | undefined => {
  return PLATFORMS.find((p) => p.id === id);
};

export const getPlatformsByCategory = (category: PlatformCategory): Platform[] => {
  return PLATFORMS.filter((p) => p.category === category);
};

export const getActivePlatforms = (): Platform[] => {
  return PLATFORMS.filter((p) => !p.comingSoon);
};
